import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrintReportComponent } from './print-report.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    PrintReportComponent

  ],
  imports: [
    CommonModule,
    MaterialModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class PrintReportModule { }
